import { debounce } from 'lodash';
import { useMemo } from 'react';
import { useHits, useSearchBox } from 'react-instantsearch';

export const useSearch = () => {
  const queryHook = useMemo(
    () => debounce((query, search) => search(query), 200),
    []
  );

  const { items, results } = useHits();
  const { query, refine } = useSearchBox({ queryHook });

  return {
    searchQuery: query,
    setSearchQuery: refine,
    searchResults: items,
    results,
  };
};
